import { Dispatch, SetStateAction } from "react";
import { Screen } from "@/models/screen";
import { Ad } from "@/models/ad";
import { Sale } from "@/models/sale";
import { fetchScreens } from "../data/fetchScreens";
import { fetchAds } from "../data/fetchAds";
import { fetchSales } from "../data/fetchSales";
import { useCallback } from "react";
import { toast } from "sonner";

export const useLoadData = (
  setScreens: Dispatch<SetStateAction<Screen[]>>,
  setAds: Dispatch<SetStateAction<Ad[]>>,
  setSales: Dispatch<SetStateAction<Sale[]>>,
  setIsLoading: Dispatch<SetStateAction<boolean>>,
  setCurrentMonthSales: Dispatch<SetStateAction<Sale[]>>,
  setExpiredAds: Dispatch<SetStateAction<Ad[]>>
) => {
  const loadData = useCallback(async () => {
    setIsLoading(true);
    try {
      console.log("Iniciando carga de datos...");
      
      // Cargar pantallas
      console.log("Cargando pantallas...");
      const screenData = await fetchScreens();
      setScreens(screenData);
      console.log("✓ Pantallas cargadas:", screenData.length);
      
      // Cargar todos los anuncios primero
      console.log("Cargando todos los anuncios...");
      try {
        const allAdsData = await fetchAds({});
        console.log("Total de anuncios cargados:", allAdsData.length);
        
        // Separar anuncios activos y vencidos
        const activeAds = allAdsData.filter(ad => !ad.isExpired && !ad.isHidden);
        const expiredAds = allAdsData.filter(ad => ad.isExpired);
        
        // Log detallado de anuncios
        console.log("Detalles de todos los anuncios:", allAdsData.map(ad => ({
          cliente: ad.clientName,
          fechaFin: ad.endDate,
          vencido: ad.isExpired,
          oculto: ad.isHidden
        })));
        
        setAds(activeAds);
        setExpiredAds(expiredAds);
        
        console.log("✓ Anuncios activos:", activeAds.length);
        console.log("✓ Anuncios vencidos:", expiredAds.length);
        
        // Log detallado de anuncios vencidos
        console.log("Detalles de anuncios vencidos:", expiredAds.map(ad => ({
          cliente: ad.clientName,
          fechaInicio: ad.startDate,
          fechaFin: ad.endDate,
          pantallas: ad.screens.map(s => s.screenName).join(", ")
        })));
        
      } catch (error) {
        console.error("Error al cargar anuncios:", error);
        toast.error("Error al cargar anuncios");
        setAds([]);
        setExpiredAds([]);
      }
      
      // Cargar ventas históricas
      console.log("Cargando ventas históricas...");
      try {
        const salesData = await fetchSales(false);
        setSales(salesData);
        console.log("✓ Ventas históricas cargadas:", salesData.length);
      } catch (error) {
        console.error("Error al cargar ventas históricas:", error);
        toast.error("Error al cargar ventas históricas");
        setSales([]);
      }
      
      // Cargar ventas del mes actual
      console.log("Cargando ventas del mes actual...");
      try {
        const currentMonthSalesData = await fetchSales(true);
        setCurrentMonthSales(currentMonthSalesData);
        console.log("✓ Ventas del mes actual cargadas:", currentMonthSalesData.length);
      } catch (error) {
        console.error("Error al cargar ventas del mes actual:", error);
        toast.error("Error al cargar ventas del mes actual");
        setCurrentMonthSales([]);
      }
      
      console.log("✓ Carga de datos completada");
      
    } catch (error) {
      console.error("Error general al cargar datos:", error);
      toast.error("Error al cargar los datos");
    } finally {
      setIsLoading(false);
    }
  }, [setScreens, setAds, setSales, setIsLoading, setCurrentMonthSales, setExpiredAds]);
  
  return { loadData };
};
